module.exports = "/lucky-balls/img/combos/7.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/combos/7.png
// module id = 229
// module chunks = 0